import { inject, Injectable, Injector, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { UserUI } from '@src/models';
import { GetBrandSettingsResponseDto } from '@src/api';
import { EnvService } from '@src/app/modules/env';

import { WelcomeDialogsComponent } from '../welcome-dialogs.component';

import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class WelcomeDialogsService {
  private readonly injector = inject(Injector);
  private readonly dialogService = inject(TuiDialogService);
  private readonly dialogs = this.dialogService.open<boolean>(
    new PolymorpheusComponent(WelcomeDialogsComponent, this.injector),
    {
      closeable: false,
      dismissible: false,
      size: 'm',
    },
  );

  private readonly env = inject(EnvService);
  private readonly permissions = inject(PermissionsService);

  private readonly allowViewingNotificationDialog = this.permissions.allowViewingNotificationDialog;
  private readonly allowViewingProfileDialog = this.permissions.allowViewingProfileDialog;

  appConfig?: GetBrandSettingsResponseDto;
  authUser?: UserUI;

  callChangeToken = signal<boolean>(false);
  dialogsCompleted$ = new BehaviorSubject<boolean>(false);

  init(appConfig: GetBrandSettingsResponseDto, authUser: UserUI) {
    this.appConfig = appConfig;
    this.authUser = authUser;

    this.permissions.getPermissions(this.env.isCordova, authUser);

    if (this.allowViewingNotificationDialog() || this.allowViewingProfileDialog()) {
      this.dialogs.subscribe(callChangeToken => {
        this.callChangeToken.set(callChangeToken);
        this.dialogsCompleted$.next(true);
      });
    } else {
      this.dialogsCompleted$.next(true);
    }
  }

  isAccessToNotifications() {
    return this.env.isAccessToNotifications();
  }
}
